import { render } from "./DownloadButtons.vue?vue&type=template&id=66627da9&scoped=true"
import script from "./DownloadButtons.vue?vue&type=script&lang=ts"
export * from "./DownloadButtons.vue?vue&type=script&lang=ts"

import "./DownloadButtons.vue?vue&type=style&index=0&id=66627da9&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-66627da9"

export default script